import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { clearAdminSession, getAdminID, getAdminToken, saveAdminSession } from "./lib/auth";
import { revokeSession } from "./lib/api";
import { PortalRoutes } from "./routes/PortalRoutes";

export default function App() {
  const [, setToken] = useState(getAdminToken());
  const [assignedID, setAssignedID] = useState(getAdminID());

  return (
    <BrowserRouter>
      <PortalRoutes
        assignedID={assignedID}
        onLogin={(value) => {
          saveAdminSession(value.token, value.assignedID, value.role);
          setAssignedID(value.assignedID);
          setToken(value.token);
        }}
        onLogout={() => {
          const token = getAdminToken();
          if (token) void revokeSession(token).catch(() => undefined);
          clearAdminSession();
          setToken(null);
        }}
      />
    </BrowserRouter>
  );
}
